// Constantes y utilidades compartidas por el formulario y la tabla de
// Disentimiento (mismas que el formulario público /consentimiento_pai).

// Municipios y áreas no municipalizadas del Amazonas
export const MUNICIPIOS = [
  "Leticia", "Puerto Nariño",
  "El Encanto", "La Chorrera", "La Pedrera", "La Victoria", "Mirití-Paraná",
  "Puerto Alegría", "Puerto Arica", "Puerto Santander", "Tarapacá",
];
export const VINCULOS = ["Madre", "Padre", "Representante legal", "Otro"];

const pad = (n) => String(n).padStart(2, "0");

// Fecha/hora LOCAL — no toISOString(), que es UTC y en Colombia (UTC-5)
// ya marca "mañana" después de las 7 p. m.
export const fechaLocalHoy = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
export const horaLocalAhora = () => {
  const d = new Date();
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Mismo formato de código que el formulario público: DIS-DDMMAAAA-HHMMSSmmm
export function generarCodigoDisentimiento() {
  const now = new Date();
  const fecha = pad(now.getDate()) + pad(now.getMonth() + 1) + now.getFullYear();
  const hora = pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds()) + String(now.getMilliseconds()).padStart(3, "0");
  return `DIS-${fecha}-${hora}`;
}

// "YYYY-MM-DD" → "DD/MM/YYYY" sin pasar por new Date() (evita el corrimiento UTC)
export const formatearFecha = (s) => {
  if (!s) return "—";
  const [y, m, d] = String(s).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const formatearEdad = (r) =>
  r.menor_edad != null && r.menor_edad !== ""
    ? `${r.menor_edad} ${(r.menor_edad_unidad || "Años").toLowerCase()}`
    : "—";

// Estado de la ficha según lo que realmente pasó (sin correo no es "fallo")
export function estadoFicha(r) {
  if (r._local) {
    return r.sincronizado === 3
      ? { texto: "⚠️ Error al sincronizar", bg: "#FCEBEB", color: "#A32D2D" }
      : { texto: "☁️ Por sincronizar", bg: "#FFF4D6", color: "#8A6100" };
  }
  if (r.ficha_estado === "enviada") return { texto: "Enviada por correo", bg: "#E5F3E3", color: "#2C6B2F" };
  if (r.ficha_estado === "fallida") {
    if (!r.representante_correo) return { texto: "PDF listo · sin correo", bg: "#EEF1F0", color: "#4C6360" };
    return { texto: "Falló el envío", bg: "#FCE7DA", color: "#CC5A26" };
  }
  return { texto: "Generando…", bg: "#FFF4D6", color: "#8A6100" };
}
